<template>
  <el-menu-item :index="handlePath(routeChildren.path)" @click="handleLink">
    <i
      v-if="['/', 'index'].includes(fullPath)"
      class="ht-fa-icon"
      :class="item.meta.icon || routeChildren.meta.icon"
    />
    <i
      v-else-if="routeChildren.meta && routeChildren.meta.icon"
      class="ht-fa-icon"
      :class="routeChildren.meta.icon"
    />
    <el-tooltip
      v-if="routeChildren.meta.title && routeChildren.meta.title.length > 8"
      :content="routeChildren.meta.title"
      placement="right-end"
    >
      <span
        class="menu-title"
        :class="{
          'sub-menu-child__title':
            routeChildren.meta && routeChildren.meta.isChildren,
        }"
      >
        {{ routeChildren.meta.title }}
      </span>
    </el-tooltip>
    <span
      v-else
      class="menu-title"
      :class="{
        'sub-menu-child__title':
          routeChildren.meta && routeChildren.meta.isChildren,
      }"
    >
      {{ routeChildren.meta.title }}
    </span>
    <i v-if="routeChildren.isNew" class="new-tag">新</i>
    <el-tag
      v-if="routeChildren.meta && routeChildren.meta.badge"
      type="danger"
      effect="dark"
    >
      {{ routeChildren.meta.badge }}
    </el-tag>
  </el-menu-item>
</template>

<script>
  import { isExternal } from '@/utils/validate'
  import path from 'path'

  export default {
    name: 'HtMenuItem',
    props: {
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
      item: {
        type: Object,
        default() {
          return null
        },
      },
      fullPath: {
        type: String,
        default: '',
      },
    },
    methods: {
      handlePath(routePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(this.fullPath)) {
          return this.fullPath
        }
        return path.resolve(this.fullPath, routePath)
      },
      handleLink() {
        const routePath = this.routeChildren.path
        const target = this.routeChildren.meta.target

        if (target === '_blank') {
          if (isExternal(routePath)) {
            window.open(routePath)
          } else if (isExternal(this.fullPath)) {
            window.open(this.fullPath)
          } else if (
            this.$route.path !== path.resolve(this.fullPath, routePath)
          ) {
            let routeData = this.$router.resolve(
              path.resolve(this.fullPath, routePath)
            )
            window.open(routeData.href)
          }
        } else {
          if (isExternal(routePath)) {
            window.location.href = routePath
          } else if (isExternal(this.fullPath)) {
            window.location.href = this.fullPath
          } else if (
            this.$route.path !== path.resolve(this.fullPath, routePath)
          ) {
            this.$router.push(path.resolve(this.fullPath, routePath))
          }
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  .el-menu-item.is-active {
    .new-tag {
      color: $base-color-white;
    }
  }
  .new-tag {
    display: inline-block;
    margin-left: 8px;
    font-size: $base-font-size-small;
    color: $base-color-white;
    width: 22px;
    height: 16px;
    border-radius: 8px 8px 8px 0;
    text-align: center;
    line-height: 16px;
    background: linear-gradient(90deg, #e55555 0%, #ff9900 100%);
  }
  .el-submenu {
    .el-menu-item {
      // margin: 0 $base-menu-bg-margin;
      min-width: 176px;
      padding-right: 0;
    }
  }
  .menu-title.sub-menu-child__title {
    font-size: 14px;
    max-width: 115px;
  }
  .is-active {
    .sub-menu-child__title {
      position: relative;
      // &::before {
      //   position: absolute;
      //   content: '';
      //   width: 6px;
      //   height: 6px;
      //   // border: 1px solid $base-color-white;
      //   border-radius: 50%;
      //   top: 6px;
      //   left: 5px;
      // }
    }
    &::v-deep .el-submenu__title {
      font-size: 14px;
    }
  }
</style>
